<template>
  <div class="select-container">
    <transition name="fade">
      <div
        ref="cover"
        class="bg j-bg"
        v-if="showContent"
        @click="handleMaskClick"
        :class="{ 'to-bottom': hasLoadPaytype }"
        :style="coverStyle"
      ></div>
    </transition>
    <transition :name="tranName" @after-leave="handleLeave">
      <section
        ref="section"
        v-if="showContent"
        class="select-wrapper"
        :class="{ 'to-bottom': hasLoadPaytype }"
        :style="sectionStyle"
      >
        <div class="select-content-bg">
          <slot name="select-content-bg"></slot>
        </div>
        <header ref="header" class="select-header" v-if="!hiddenHeader">
          <slot name="select-header"></slot>
          <Icon
            class="select-close flex-center"
            :name="isLandscape ? 'close' : 'down'"
            @click="close"
            v-if="isShowClose"
          />
        </header>
        <div class="select-content">
          <slot name="select-content"></slot>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import selectHeightFix from '../../diractives/store/selectHeightFix';
import style from '@mixins/officialTopupNew/style';

export default {
  name: 'select-container',
  mixins: [style],
  props: {
    showChildSelect: {
      type: Boolean,
      default: false
    },
    hiddenHeader: {
      type: Boolean,
      default: false
    },
    isShowClose: {
      type: Boolean,
      default: false
    }
  },
  directives: { selectHeightFix },
  data() {
    return {
      showContent: false,
      hammer: null,
      coverStyle: '',
      sectionStyle: ''
    };
  },
  computed: {
    ...mapState({
      hasLoadPaytype: state => state.hasLoadPaytype
    })
  },
  methods: {
    handleMaskClick() {
      if (this?.$refs?.section) {
        this.$refs.section.style = ''
      }
      if (this?.$refs?.cover) {
        this.$refs.cover.style = ''
      }
      this.$nextTick(() => {
        this.showContent = false;
      });
    },
    handleLeave() {
      this.close();
    },
    close() {
      this.showContent = false;
      setTimeout(() => {
        this.$emit('closeSelectContainer');
      }, 300);
    }
  },
  mounted() {
    this.showContent = true;
  },
  beforeDestroy() {
    this.showContent = false;
    this?.hammer?.destroy();
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';

.select-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 6;
}
.select-wrapper {
  position: absolute;
  bottom: $tabbarHeight;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 70vh;
  max-height: 70vh;
  background-color: $backgroundColor;
  z-index: 2;
  border-radius: 20px 20px 0 0;
}
.select-close {
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.select-header {
  position: relative;
  display: flex;
  height: 106px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 26px;
  box-sizing: border-box;
  padding: 0 40px;
  color: #333;
}
.bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgb(0, 0, 0, 0.3);
}
.select-content {
  // position: relative;
  display: inline-block;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 40px;
  width: 100%;
  height: calc(100% - 90px);
}
.select-content > ul.ocean-ui-list {
  padding-bottom: 80px;
}

.select-content-bg {
  z-index: -1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

#ssr-page.landscape {
  .select-container {
    .select-wrapper {
      width: 750px;
      left: 50%;
      margin-left: unset;
      max-height: fit-content;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 20px;
      height: 630px;
      padding-bottom: 20px;
    }
  }
}
</style>
